import { baseApi, QueryPayload } from 'src/api';
import { AxiosError } from 'axios';
import { Buffer } from 'buffer';

const apiModule = baseApi.injectEndpoints({
    endpoints: builder => ({
        changePassword: builder.mutation<
            void,
            { body: { oldPassword: string; newPassword: string } }
        >({
            query: ({ body }): QueryPayload => ({
                url: '/me/password/change',
                method: 'POST',
                data: body,
            }),
        }),

        getProfileImage: builder.query<
            { buffer: ArrayBuffer; base: string } | null,
            void
        >({
            providesTags: [{ type: 'Avatar', id: 'SELF' }],
            query: (): QueryPayload => ({
                url: '/me/avatar',
                method: 'GET',
                responseType: 'arraybuffer',
            }),
            transformResponse: (response: ArrayBuffer) => {
                if (!response || !response.byteLength) return null;

                return {
                    buffer: response,
                    base: Buffer.from(response).toString('base64'),
                };
            },
        }),

        resetProfileImage: builder.mutation<void, void>({
            invalidatesTags: [{ type: 'Avatar', id: 'SELF' }],
            query: (): QueryPayload => ({
                url: '/me/avatar',
                method: 'DELETE',
            }),
        }),

        uploadProfileImage: builder.mutation<void, { payload: { file: Blob } }>(
            {
                invalidatesTags: [{ type: 'Avatar', id: 'SELF' }],
                query: ({ payload }): QueryPayload => {
                    const formData = new FormData();

                    formData.append('file', payload.file);

                    return {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        data: formData,
                        url: '/me/avatar',
                        method: 'PUT',
                        errorMessage: (response: AxiosError) => {
                            if (response.response?.status === 400) {
                                return 'Вес изображения слишком велик';
                            }

                            return 'Произошла ошибка при выполнении запроса';
                        },
                    };
                },
            }
        ),
    }),
});

export const {
    useGetProfileImageQuery,
    useResetProfileImageMutation,
    useUploadProfileImageMutation,
    useChangePasswordMutation,
} = apiModule;
